import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { popMe, popLogout } from '../lib/popApi';

const Ctx = createContext(null);

export const PoPAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await popMe();
      setUser(me);
      return me;
    } catch (_e) {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // PoPAuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const doLogout = async () => {
    try { await popLogout(); } catch (_e) {}
    setUser(null);
    window.location.href = '/pop';
  };

  return (
    <Ctx.Provider value={{ user, loading, refresh, logout: doLogout, setUser }}>
      {children}
    </Ctx.Provider>
  );
};

export const usePoPAuth = () => useContext(Ctx) || { user: null, loading: false, refresh: () => {}, logout: () => {} };
